import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';
import * as formValidators from '../../scripts/formValidators';
import {
  MotifButton,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifErrorMessage,
  MotifModal,
  MotifFormField,
} from '@ey-xd/motif-react';

const EditGroupForm = ({
  editGroup,
  handleCloseForm,
  error,
  submitting,
  handleDismissErrorMessage,
  showEditGroupRowDataModal,
  toggleShowEditGroupRowDataModal,
  handleSubmit,
  onSubmit,
  validationMessage,
  clearValidationMessage,
}) => {
  const closeButtonProps = {
    title: 'Edit Group',
    'aria-label': 'Edit Group',
    'data-testid': 'close',
  };

  let save = (e) => {
    e.preventDefault();
    handleSubmit((values) => onSubmit({ ...values }))();
  };

  return (
    <MotifModal
      show={showEditGroupRowDataModal}
      onClose={toggleShowEditGroupRowDataModal}
      variant="default"
      size="lg"
      data-testid="divEditGroupModal"
    >
      <form onSubmit={handleSubmit} id="editGroupForm">
        <MotifModalHeader
          closeButtonProps={closeButtonProps}
          data-testid="mdHdrEditGroups"
        >
          Edit Group
        </MotifModalHeader>
        <MotifModalBody>
          <MotifFormField>
            <Field
              name="EntityGroupID"
              type="hidden"
              component="input"
              label=""
            />
            {formHelpers.showSubmissionError(error, handleDismissErrorMessage)}
            <div className="row">
              <div className="field col-md-12">
                <Field
                  name="EntityGroupName"
                  component={formHelpers.renderField}
                  type="text"
                  label="Group Name"
                  dataTestId="txtGroupName"
                  maxLength={255}
                  isRequiredField={true}
                  validate={[
                    formValidators.required,
                    formValidators.alphaNumeric,
                    formValidators.maxLength255,
                  ]}
                  onChange={clearValidationMessage}
                />
                {(validationMessage && (
                  <MotifErrorMessage variant="error">
                    {validationMessage}
                  </MotifErrorMessage>
                )) ||
                  null}
              </div>
            </div>
          </MotifFormField>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            variant="secondary"
            type="button"
            data-testid="btnCancel"
            onClick={handleCloseForm}
          >
            Cancel
          </MotifButton>

          <MotifButton
            variant="primary"
            type="submit"
            form="editGroupForm"
            data-testid="btnSave"
            value="Submit"
            onClick={save}
            disabled={submitting}
          >
            Save
          </MotifButton>
        </MotifModalFooter>
      </form>
    </MotifModal>
  );
};

EditGroupForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    EntityGroupID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    EntityGroupName: PropTypes.string,
  }),
  error: PropTypes.string,
  submitting: PropTypes.bool,
  handleDismissErrorMessage: PropTypes.func,
  showEditGroupRowDataModal: PropTypes.bool.isRequired,
  toggleShowEditGroupRowDataModal: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'editGroupForm',
  enableReinitialize: true,
})(EditGroupForm);
